import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import createCustomQRCode from '../../inputs/createCustomQRCode';
import html2pdf from 'html2pdf.js';
import axios from 'axios';
import domain from "../../../util/domain";


export default function GeneratePDF() {
    const [imgData, setImgData] = useState(null);
    const [template, setTemplate] = useState('');
    const contentRef = useRef(null);
    const location = useLocation();
    const [page1, setPage1] = useState('');
    const [page2, setPage2] = useState('');
    const visitData = location.state?.visit;
    const [students, setStudents] = useState([]);
    const [allStudents, setAllStudents] = useState([]); // Store all fetched students
    const [selectedStudents, setSelectedStudents] = useState([]); // Store selected student IDs
    const [showStudentSelection, setShowStudentSelection] = useState(false); // Control student selection UI
    const [isSelfPlaced, setIsSelfPlaced] = useState(false);
    const [courseType, setCourseType] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedYop, setSelectedYop] = useState(new Date().getFullYear() - 3);
    const [hods, setHods] = useState([]);
    const [tpos, setTpos] = useState([]);
    const [isHodSelected, setIsHodSelected] = useState(false);
    const [isTpoSelected, setIsTpoSelected] = useState(false);
    const [selectedHod, setSelectedHod] = useState('');
    const [selectedTpo, setSelectedTpo] = useState('');
    const [isGenerating, setIsGenerating] = useState(false);
    const [isTemplateLoading, setIsTemplateLoading] = useState(false);
    const page2footerES = `<span ><b  class="bhead">Embedded Systems Course Modules:</b><br />
    C, DS, C++, ARM, Linux, TCP/IP, RTOS, 8051, Embedded C.<br />
    <b class="bhead">Duration of the Course :</b> 6 months <br /><br /></span>
    <span><b class="bhead"> Vector India Key Highlights:</b><br />
    <ul><li>
    <b>Highest Package: </b>₹21.71 LPA</li>
    <li><b>Average Package: </b>₹4.5 LPA</li>
    <li><b>Exceptional placement record: </b>1,306 students successfully placed in 2025.</li>
    <li><b>Trusted by leading companies: </b>614 campus drives in 2025.</li>
    <li><b>Self placed 700+ students</b></li>
    <li><b>100% Genuine Placement Assistance</b></li>
    </ul>
    </span>
    
    <div class="social-media">
        <a href="https://www.linkedin.com/company/vectorindia" target="_blank">
            <img src="linkedin.png" alt="LinkedIn" >
        </a>
        <a href="https://www.facebook.com/VectorInstitute" target="_blank">
            <img src="facebook.png" alt="Facebook" >
        </a>
        <a href="https://twitter.com/Vector_India" target="_blank">
            <img src="twitter.png" alt="X (formerly Twitter)" >
        </a>
        <a href="http://www.instagram.com/vectorindiainstitute" target="_blank">
            <img src="insta.png" alt="Instagram" >
        </a>
        <a href="https://www.youtube.com/@VectorIndia9" target="_blank">
            <img src="youtube.png" alt="YouTube" >
        </a>
    </div>
<br />
Kindly note that 2026 passouts are also eligible for the scholarship test.
<br />
<br />
<b>Thanking you</b>
<br />
<br />
<b>Regards</b><br />
Vector India
<br />
<br />`;

    const page2footerFSFull = `<span ><b class="bhead">Full Stack Development Course Modules:</b><br />
    <ul><li>
    <b class="bhead">Programming Languages:</b> Python, Java.</li>
    <li> <b class="bhead">Front End:</b> HTML, JavaScript, CSS, ReactJS, Bootstrap.</li>
    <li> <b class="bhead">Databases:</b> MySQL, MongoDB. </li>
    <li> <b class="bhead">Back End:</b> Node.js, Express.</li>
    <li> <b class="bhead">Version Control:</b> Git.</li>
    </ul>
    <b class="bhead">Duration of the Course :</b> 6 months <br /><br />
    </span>
    <span><b class="bhead"> Vector India Key Highlights:</b>
    <ul><li>
    <b>Highest Package: </b>₹21.71 LPA. <b>Average Package: </b>₹4.5 LPA</li>
    <li><b>Exceptional placement record: </b>1,306 students successfully placed in 2025.</li>
    <li><b>Trusted by leading companies: </b>614 campus drives in 2025.</li>
    <li><b>Self placed 700+ students</b></li>
    <li><b>100% Genuine Placement Assistance</b></li>
    </ul>
    </span>
    
    <div class="social-mediaF">
        <a href="https://www.linkedin.com/company/vectorindia" target="_blank">
            <img src="linkedin.png" alt="LinkedIn" >
        </a>
        <a href="https://www.facebook.com/VectorInstitute" target="_blank">
            <img src="facebook.png" alt="Facebook" >
        </a>
        <a href="https://twitter.com/Vector_India" target="_blank">
            <img src="twitter.png" alt="X (formerly Twitter)" >
        </a>
        <a href="http://www.instagram.com/vectorindiainstitute" target="_blank">
            <img src="insta.png" alt="Instagram" >
        </a>
        <a href="https://www.youtube.com/@VectorIndia9" target="_blank">
            <img src="youtube.png" alt="YouTube" >
        </a>
    </div>
<br />
Kindly note that 2026 passouts are also eligible for the scholarship test.
<br />
<b>Thanking you</b>
<br />
<b>Regards</b>
<br />Vector India
<br />
<br />`;

    const page2footerFS = `<span ><b class="bhead">Full Stack Development Course Modules:</b><br />
    <b class="bhead">Programming Languages:</b> Python, Java. <b class="bhead">Front End:</b> HTML, JavaScript, CSS, ReactJS, Bootstrap. <b class="bhead">Databases:</b> MySQL, MongoDB. <b class="bhead">Back End:</b> Node.js, Express. <b class="bhead">Version Control:</b> Git.<br />
    <b class="bhead">Duration of the Course :</b> 6 months <br /><br />
    </span>
    <span><b class="bhead"> Vector India Key Highlights:</b>
    <ul><li>
    <b>Highest Package: </b>₹21.71 LPA. <b>Average Package: </b>₹4.5 LPA</li>
    <li><b>Exceptional placement record: </b>1,306 students successfully placed in 2025.</li>
    <li><b>Trusted by leading companies: </b>614 campus drives in 2025.</li>
    <li><b>Self placed 700+ students</b></li>
    <li><b>100% Genuine Placement Assistance</b></li>
    </ul>
    </span>
    
    <div class="social-media">
        <a href="https://www.linkedin.com/company/vectorindia" target="_blank">
            <img src="linkedin.png" alt="LinkedIn" >
        </a>
        <a href="https://www.facebook.com/VectorInstitute" target="_blank">
            <img src="facebook.png" alt="Facebook" >
        </a>
        <a href="https://twitter.com/Vector_India" target="_blank">
            <img src="twitter.png" alt="X (formerly Twitter)" >
        </a>
        <a href="http://www.instagram.com/vectorindiainstitute" target="_blank">
            <img src="insta.png" alt="Instagram" >
        </a>
        <a href="https://www.youtube.com/@VectorIndia9" target="_blank">
            <img src="youtube.png" alt="YouTube" >
        </a>
    </div>
<br />
Kindly note that 2026 passouts are also eligible for the scholarship test.
<br />
<b>Thanking you</b>
<br />
<b>Regards</b><br />
Vector India
<br />
<br />`;

    // /Vector India website url
    // vectorindia.org

    // linkedin.com
    // linkedin.com/company/vectorindia

    // facebook.com
    // facebook.com/VectorInstitute

    // instagram.com
    // instagram.com/vectorindiainstitute

    // twitter.com
    // twitter.com/Vector_India

    const studentPhoto = async (student, fullWidth = false) => {
        let photoSrc = '';
        try {
            // Add timeout to prevent hanging requests
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

            const photo = await axios.get(`${domain}/pdf/photo?studentId=${student.studentid}`, {
                signal: controller.signal
            });

            clearTimeout(timeoutId);

            if (photo?.data?.base64) {
                photoSrc = photo.data.base64;
            } else if (Array.isArray(photo?.data) && photo.data.length > 0 && photo.data[0]?.photo?.data) {
                // Convert Buffer data array to base64
                const uint8Array = new Uint8Array(photo.data[0]?.photo?.data);
                const base64String = btoa(String.fromCharCode.apply(null, uint8Array));
                photoSrc = `data:image/jpeg;base64,${base64String}`;
            }
        } catch (error) {
            console.error('Error processing photo for student:', student.studentid, error);
            photoSrc = ''; // Set to default image if there's an error
        }
        const campusName = student.companyid.replace("_FS", "");
        const fwidth = fullWidth ? `class="photo-boxesF"` : `class="photo-boxes"`;
        return `<div  ${fwidth} ><img src="${photoSrc}"  onerror="this.src='default-avatar.jpg';" />
                        <p style="margin-bottom: 5px;"> <span class="names">${student.name}</span><br />
                            <span class="names">${student.specialization} - ${student.yop}</span><br />
                            <span class="name">@${campusName}</span>
                        </p></div>`;
    }

    useEffect(() => {
        const processTemplate = async () => {
            // Don't process if required data is not available
            if (!page1 || !page2 || students.length === 0) {
                return;
            }

            setIsTemplateLoading(true);
            try {
                // Load HTML template
                let modifiedHtml = 'NO STUDENTS FOUND';
                if (students.length > 0) {
                    let filteredStudents = students.filter(student => (courseType === false) ? !student.companyid.endsWith("_FS") : student.companyid.endsWith("_FS"));
                    if (filteredStudents.length === 0) {
                        modifiedHtml = `NO STUDENTS FOUND ${(courseType) ? "FOR FULL STACK" : "FOR EMBEDDED"}`;
                        setTemplate(modifiedHtml);
                        setIsTemplateLoading(false);
                        return;
                    }

                    modifiedHtml = page1;
                    if (imgData) {
                        modifiedHtml = modifiedHtml.replace('{{qrcode}}', `<div class="qrphoto-boxes"><span class="
                                    name">Apply Now</span> <img width="100%" src="${imgData}" alt="QR Code" /><span class="name">Scholarship upto 50%</span></div>`);
                    } else {
                        modifiedHtml = modifiedHtml.replace('{{qrcode}}', '');
                    }
                    if (visitData) {
                        modifiedHtml = modifiedHtml
                            .replace('{{college_name}}', visitData.college_name || '')
                        // Add more replacements as needed
                    }

                    if (courseType) {
                        modifiedHtml = modifiedHtml.replaceAll('{{course}}', "Full Stack Development");
                        modifiedHtml = modifiedHtml.replace('{{subject}}', "Hyderabad");
                    } else {
                        modifiedHtml = modifiedHtml.replaceAll('{{course}}', "Embedded Systems");
                        modifiedHtml = modifiedHtml.replace('{{subject}}', "Hyderabad/Bangalore/Chennai");
                    }

                    if (isHodSelected) {
                        var hod = hods.find(hod => hod.id === parseInt(selectedHod));

                        if (hod) {
                            modifiedHtml = modifiedHtml.replace('{{hodName}}', hod.hodname || '');
                            modifiedHtml = modifiedHtml.replace('{{deptName}}', 'HOD - ' + hod.branch || '');
                        }
                    }
                    if (isTpoSelected) {
                        var tpo = tpos.find(tpo => tpo.id === parseInt(selectedTpo));
                        if (tpo) {
                            modifiedHtml = modifiedHtml.replace('{{hodName}}', tpo.tponame || '');
                            modifiedHtml = modifiedHtml.replace('{{deptName}}', 'Training and Placement Officer');
                        }
                    }
                    if (isHodSelected === false && isTpoSelected === false) {
                        modifiedHtml = modifiedHtml.replace('{{deptName}}', 'The Principal');
                        modifiedHtml = modifiedHtml.replace('{{hodName}}', '');
                    }
                    let imagebox = '';
                    let fullWidth = (filteredStudents.length < 4) ? true : false;
                    for (let i = 0; i < filteredStudents.length; i++) {
                        if (i === 4) {
                            break;
                        }
                        imagebox += await studentPhoto(filteredStudents[i], fullWidth);
                    }
                    modifiedHtml = modifiedHtml.replace('{{photoBox}}', imagebox);

                    if (filteredStudents.length > 4) {
                        const rows = 3; // Number of rows
                        const cols = 4; // Number of columns
                        const studentsPerPage = rows * cols
                        let requiedNextPage = false;
                        for (let i = 4; i < filteredStudents.length; i += studentsPerPage) {
                            const pageStudents = filteredStudents.slice(i, i + studentsPerPage);
                            fullWidth = ((pageStudents.length > 4 && pageStudents.length < 7)) ? true : false;
                            let pagePhotos = '';
                            for (let r = 0; r < rows; r++) {
                                const rowStudents = pageStudents.slice(r * cols, (r + 1) * cols);
                                // Fix: Use Promise.all to handle async calls properly
                                const rowPhotos = await Promise.all(rowStudents.map(s => studentPhoto(s, fullWidth)));
                                pagePhotos += rowPhotos.join("");
                            }
                            let npage = page2;
                            if (pageStudents.length >= 5) {
                                npage = npage.replace('{{page2footer}}', "");
                            } else {
                                npage = npage.replace('{{page2footer}}', (courseType) ? page2footerFS : page2footerES);
                            }
                            modifiedHtml += npage.replace('{{photoBox}}', pagePhotos);
                            if (pageStudents.length >= 5 && (i + studentsPerPage) >= students.length) {
                                requiedNextPage = true;
                            }
                        }

                        if (requiedNextPage) {
                            let lastp = page2;
                            modifiedHtml += lastp.replace('{{photoBox}}', "").replace('{{page2footer}}', (courseType) ? page2footerFSFull : page2footerES);
                        }
                    } else {
                        let lastp = page2;
                        modifiedHtml += lastp.replace('{{photoBox}}', "").replace('{{page2footer}}', (courseType) ? page2footerFSFull : page2footerES);
                    }
                }
                setTemplate(modifiedHtml);
            } catch (error) {
                console.error('Error processing template:', error);
                setTemplate('Error processing template');
            } finally {
                setIsTemplateLoading(false);
            }
        };

        processTemplate();
    }, [visitData, students, imgData, page1, page2, courseType, isHodSelected, isTpoSelected, selectedHod, selectedTpo, hods, tpos]);

    useEffect(() => {
        const loadQRCode = async () => {
            const data = await createCustomQRCode(`https://www.vectorindia.org/registration?utm_source=${visitData?.college_code}&utm_medium=pdf&utm_campaign=vectorcv`);
            setImgData(data);
            const page1 = await fetch('/pdfpage1.html').then(response => response.text());
            const page2 = await fetch('/pdfpage2.html').then(response => response.text());
            setPage1(page1);
            setPage2(page2);
        };
        loadQRCode();
        setIsLoading(true);

    }, [visitData]);

    useEffect(() => {
        if (visitData?.id) {
            axios.get(`${domain}/hods?college_id=${visitData.id}`)
                .then((response) => {
                    //console.log("HODs data: ", response.data);
                    setHods(response.data);
                })
                .catch((error) => {
                    //console.log("Error fetching HODs: ", error);
                    setHods([]);
                });
            axios.get(`${domain}/tpos?college_id=${visitData.id}`)
                .then((response) => {
                    //console.log("TPOS data: ", response.data);
                    setTpos(response.data);
                })
                .catch((error) => {
                    //console.log("Error fetching TPOS: ", error);
                    setTpos([]);
                });
        }
    }, [visitData]);

    const handleDownloadPDF = () => {
        const element = contentRef.current;
        let filenamepdf = '';
        if (isHodSelected === false && isTpoSelected === false) {
            filenamepdf = `${visitData?.college_name}-Principal.pdf`;
        } else {
            filenamepdf = `${visitData?.college_name}-${(isHodSelected ? hods.find(hod => hod.id === parseInt(selectedHod)).hodname + " - HOD" : tpos.find(tpo => tpo.id === parseInt(selectedTpo)).tponame + " - TPO")}.pdf`;
        }
        const options = {
            margin: 0.2,
            filename: filenamepdf,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 5, logging: true, useCORS: true },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        };
        html2pdf().set(options).from(element).save();

    };

    const generateYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = currentYear; year >= currentYear - 15; year--) {
            years.push(year);
        }
        return years;
    };

    // Student selection functions
    const handleSelectAll = () => {
        const allStudentIds = allStudents.map(student => student.studentid);
        setSelectedStudents(allStudentIds);
    };

    const handleDeselectAll = () => {
        setSelectedStudents([]);
    };

    const handleStudentToggle = (studentId) => {
        console.log('Toggling student:', studentId);
        setSelectedStudents(prev => {
            if (prev.includes(studentId)) {
                const newSelection = prev.filter(id => id !== studentId);
                console.log('Removed student, new selection:', newSelection);
                return newSelection;
            } else {
                const newSelection = [...prev, studentId];
                console.log('Added student, new selection:', newSelection);
                return newSelection;
            }
        });
    };

    const handleViewPDF = () => {
        const filteredStudents = allStudents.filter(student => selectedStudents.includes(student.studentid));
        setStudents(filteredStudents);
        setShowStudentSelection(false);
    };

    const updatePDF = () => {
        //console.log("updatePDF: selectedYop: ", selectedYop);
        setStudents([]);
        setAllStudents([]);
        setSelectedStudents([]);
        setIsLoading(true);
        setIsGenerating(true);
        axios.get(`${domain}/pdf?collegeCode=${visitData?.college_code}&yop=${selectedYop}&selfPlaced=${isSelfPlaced}`).then((response) => {
            //for testing add more students
            // const morestudents = response.data.concat(response.data);
            // const morestudents = response.data.join(response.data);
            //console.log("Studentdetails ", response.data);
            const studentsData = response.data || [];
            setAllStudents(studentsData);
            
            // Check if response is empty
            if (studentsData.length === 0) {
                setShowStudentSelection(false);
                setIsLoading(false);
                setIsGenerating(false);
                return;
            }
            
            //select based on course type
            if (courseType) {
                const filteredStudents = studentsData.filter(student => student.companyid.endsWith("_FS"));
                setSelectedStudents(filteredStudents.map(student => student.studentid));
                if (filteredStudents.length === 0) {
                    setShowStudentSelection(false);
                    setIsLoading(false);
                    setIsGenerating(false);
                    return;
                }
            } else {
                const filteredStudents = studentsData.filter(student => !student.companyid.endsWith("_FS"));
                setSelectedStudents(filteredStudents.map(student => student.studentid));
                if (filteredStudents.length === 0) {
                    setShowStudentSelection(false);
                    setIsLoading(false);
                    setIsGenerating(false);
                    return;
                }
            }
            setShowStudentSelection(true);
            setIsLoading(false);
            setIsGenerating(false);
        })
            .catch((error) => {
                //console.log("pdf students: useEffect: error: ", error);
                setStudents([]);
                setAllStudents([]);
                setSelectedStudents([]);
                setShowStudentSelection(false);
                setIsLoading(false);
                setIsGenerating(false);
            });
    }
    return (

        <div>
            {visitData && (
                <div style={{
                    marginBottom: '20px',
                    padding: '15px',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '8px',
                    border: '1px solid #ddd'
                }}>
                    <h2 style={{
                        margin: 0,
                        color: '#eb7a24',
                        fontSize: '24px',
                        fontWeight: 'bold'
                    }}>
                        {visitData.college_name}
                    </h2>
                    {visitData.college_code && (
                        <p style={{
                            margin: '5px 0 0 0',
                            color: '#666',
                            fontSize: '14px'
                        }}>
                            Code: {visitData.college_code}
                        </p>
                    )}
                </div>
            )}
            <div>
                { }
                <span>YOP : </span>
                <select
                    value={selectedYop}
                    onChange={(e) => setSelectedYop(parseInt(e.target.value))}
                    style={{
                        padding: '5px',
                        marginRight: '10px',
                        borderRadius: '4px',
                        border: '1px solid #ccc'
                    }}
                >
                    {generateYearOptions().map(year => (
                        <option key={year} value={year}>{year}</option>
                    ))}
                </select>

                <span style={{ marginLeft: '10px' }}>HOD : </span>
                <select
                    value={selectedHod}
                    onChange={(e) => { setSelectedHod(e.target.value); setIsHodSelected(true); setIsTpoSelected(false); setSelectedTpo("Select TPO") }}
                    style={{
                        padding: '5px',
                        marginRight: '10px',
                        borderRadius: '4px',
                        border: '1px solid #ccc'
                    }}
                >
                    <option value="">Select HOD</option>
                    {hods.map(hod => (
                        <option key={hod.id} value={hod.id}>
                            {hod.hodname} - {hod.branch}
                        </option>
                    ))}
                </select>

                <span style={{ marginLeft: '10px' }}>TOP : </span>
                <select
                    value={selectedTpo}
                    onChange={(e) => { setSelectedTpo(e.target.value); setIsHodSelected(false); setIsTpoSelected(true); setSelectedHod("Select HOD") }}
                    style={{
                        padding: '5px',
                        marginRight: '10px',
                        borderRadius: '4px',
                        border: '1px solid #ccc'
                    }}
                >
                    <option value="">Select TPO</option>
                    {tpos.map(tpo => (
                        <option key={tpo.id} value={tpo.id}>
                            {tpo.tponame}
                        </option>
                    ))}
                </select>
                <input type="checkbox" name="selfPlaced" id="selfPlaced" onChange={(e) => setIsSelfPlaced(e.target.checked)} checked={isSelfPlaced} />
                <label htmlFor="selfPlaced">Self Placed</label>&nbsp;&nbsp;&nbsp;
                <input type="checkbox" name="courseType" id="courseType" onChange={(e) => setCourseType(e.target.checked)} checked={courseType} />
                <label htmlFor="courseType">Course : {courseType ? "Full Stack" : "Embedded"}</label>&nbsp;&nbsp;&nbsp;
                <button onClick={updatePDF}>View PDF</button>&nbsp;&nbsp;&nbsp;
                {students.length > 0 && !showStudentSelection && (
                    <button
                        onClick={handleDownloadPDF}
                        style={{
                            marginTop: '20px',
                            padding: '10px 20px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer'
                        }}
                    >
                        Download PDF
                    </button>
                )}
            </div>
            {isLoading ? <div><h2>{isGenerating ? "Generating PDF..." : "Select YOP and HOD and click on generate PDF"}</h2></div> : ""}

            {/* Student Selection Interface */}
            {showStudentSelection && allStudents.length > 0 && (
                <div style={{ margin: '20px 0', padding: '20px', border: '1px solid #ddd', borderRadius: '8px', backgroundColor: '#f9f9f9' }}>
                    <h3>Select Students for PDF ({selectedStudents.length} of {allStudents.length} selected)</h3>

                    <div style={{ marginBottom: '15px' }}>
                        <button
                            onClick={handleSelectAll}
                            style={{
                                padding: '8px 16px',
                                marginRight: '10px',
                                backgroundColor: '#28a745',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Select All
                        </button>
                        <button
                            onClick={handleDeselectAll}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: '#dc3545',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Deselect All
                        </button>
                        <button
                            onClick={handleViewPDF}
                            disabled={selectedStudents.length === 0}
                            style={{
                                padding: '8px 16px',
                                marginLeft: '10px',
                                backgroundColor: selectedStudents.length === 0 ? '#6c757d' : '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: selectedStudents.length === 0 ? 'not-allowed' : 'pointer'
                            }}
                        >
                            View PDF ({selectedStudents.length} students)
                        </button>
                    </div>

                    <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: 'white' }}>
                        {allStudents.map((student) => (
                            <div
                                key={student.studentid}
                                style={{
                                    padding: '10px',
                                    borderBottom: '1px solid #eee',
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: selectedStudents.includes(student.studentid) ? '#e3f2fd' : 'transparent'
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={selectedStudents.includes(student.studentid)}
                                    onChange={() => handleStudentToggle(student.studentid)}
                                    style={{ marginRight: '10px' }}
                                />
                                <div>
                                    <strong>{student.name}</strong> - {student.specialization} ({student.yop})
                                    <br />
                                    <small style={{ color: '#666' }}>Company: {student.companyid}</small>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* PDF Preview */}
            {students.length > 0 && !showStudentSelection && (
                <div>
                    {isTemplateLoading ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <h3>Processing PDF template...</h3>
                            <p>Please wait while we load student photos and generate the PDF.</p>
                        </div>
                    ) : (
                        <div ref={contentRef}>
                            {/* Render the template */}
                            <div dangerouslySetInnerHTML={{ __html: template }} />
                        </div>
                    )}
                </div>
            )}

            {!isLoading && !showStudentSelection && students.length === 0 && (
                <div><h2>No Students found</h2></div>
            )}

        </div >
    );
}
